<div class="row mb-4 dynamic-select-row">
  <ng-container *ngFor="let config of selectConfig">
    <div *ngIf="!config.hidden"
         class="{{ config.class }} mb-2">
      <label class="form-label select-label"
             [style.color]="config.labelColor || defaultLabelColor">
        {{ config.label }}
        <span *ngIf="config.required"
              class="text-danger ms-1">*</span>
      </label>

      <ng-select class="custom"
                 [items]="getSelectItems(config) | async"
                 [placeholder]="config.placeholder || 'Selecione uma opção'"
                 [loading]="selectLoading[config.key]"
                 [typeahead]="readonly ? null : (config.typeahead ? selectInput$[config.key] : null)"
                 [ngModel]="getSelectedValue(config.key)"
                 [bindLabel]="config.bindLabel || 'name'"
                 [bindValue]="config.bindValue || 'id'"
                 [multiple]="config.multiple || false"
                 (ngModelChange)="readonly ? null : onValueChange(config.key, $event)"
                 (typeahead)="readonly ? null : onSelectInputChange(config.key, $event)"
                 (focus)="readonly ? null : onFieldFocus()"
                 (blur)="readonly ? null : onFieldBlur(config.key)"
                 [clearable]="!readonly && (config.multiple || false)"
                 [searchable]="!readonly"
                 [readonly]="readonly || isDefaultConfiguration">
        <ng-template ng-option-tmp
                     let-item="item">
          <div>
            {{ getDisplayValue(item, config) }}
          </div>
        </ng-template>
      </ng-select>
    </div>
  </ng-container>
</div>